module.exports = __webpack_public_path__ + "befa76aa53c2b2b056d5ba21d3609714.svg";